import { TestPermission, TestPermissions } from './Permissions'
export class AuthAccountInfo {
  constructor (props) {
    Object.assign(this, props)
    this.IsAuthenticated = props ? true : false // eslint-disable-line
  }

  HasPermission (permission) {
    return TestPermission(this.PermissionNames || [], permission)
  }

  HasPermissions (permissions, requireAll = false) {
    return TestPermissions(this.PermissionNames || [], permissions, requireAll)
  }
}
